/**
 * 编辑地址相关文案
 */
export default {
  addressForm: {
    name: {
      label: 'Full Name',
      placeholder: 'Full Name',
    },
    phone: {
      label: 'Mobile Number',
      placeholder: 'Mobile Number',
    },
    postcode: {
      label: 'Postcode',
      placeholder: 'Zip Code',
    },
    address1: {
      label: 'Address Line 1',
      placeholder: 'Address Line 1',
    },
    address2: {
      label: 'Address Line 2',
      placeholder: 'Address Line 2 (optional)',
    },
    city: {
      label: 'Town/City',
      placeholder: 'Town/City',
    },
    state: {
      label: 'State',
      placeholder: 'State',
    },
    suburb: {
      label: 'Suburb',
      placeholder: 'Suburb',
    },
    country: {
      label: '國家',
      placeholder: '國家',
    },
  },
  saveText: 'Save',
  billingAddress: 'Billing Address ',
  deliveryAddress: ' Delivery Address',
  billingAddressTip: ' Please provide your billing address for invoice',
  materialsTip: 'Add a new address to receive learning materials',
  editText: 'Edit Address',
}
